import React, { useEffect, useRef, useState } from 'react';
import { useIntroPage } from '../../IntroPageProvider';
import './index.css'

export default function VideoPlayer({
    duration,
    playListEnded,
}) {
    const videoRef = useRef(null);
    const [isFirstFrameLoaded, setIsFirstFrameLoaded] = useState(false);
    const {
        isMuted,
        playingVideoIndex,
        setVideoElement,
        autoplayPermissionsDenied,
        setAutoplayPermissionsDenied,
        isUserInteractWithVideoPlayer,
        setPlayingVideoIndex,
        setIsVideoBuffering,
        playList,
        updateVideoPlayingState,
    } = useIntroPage();
    useEffect(() => {
        setIsPlayerInteracted(isUserInteractWithVideoPlayer);
    }, [isUserInteractWithVideoPlayer])

    /** Player interacted state */
    const isPlayerInteractedRef = useRef(false);
    const setIsPlayerInteracted = data => {
        isPlayerInteractedRef.current = data;
    };

    /** Set playing Video */
    const videoIndexRef = useRef(0);
    const setVideoIndex = data => {
        videoIndexRef.current = data;
    };

    useEffect(() => {
        setVideoIndex(playingVideoIndex);
        setIsFirstFrameLoaded(false);
    }, [playingVideoIndex])
    /** */

    const onloadMeta = () => {
        duration({ index: videoIndexRef.current, range: videoRef.current.duration * 1000 });
    }

    const loadeddata = () => {
        if (autoplayPermissionsDenied) {
            if (isPlayerInteractedRef.current) {
                videoRef.current.load();
            }
        }
        setIsFirstFrameLoaded(true);
    }

    const ended = () => {
        const nextVideo = videoIndexRef.current + 1;
        updateVideoPlayingState(videoIndexRef.current);
        if (nextVideo < playList.length) {
            setPlayingVideoIndex(nextVideo);
        } else {
            playListEnded();
        }
    }

    const playing = () => {
        setIsVideoBuffering(false);
    }

    const waiting = () => {
        setIsVideoBuffering(true);
    }

    const error = (e) => {
        console.error('error', e.target.error);
        ended();
    }

    useEffect(() => {
        if (videoRef.current) {
            setVideoElement(videoRef);
            videoRef.current.addEventListener('error', error)
            videoRef.current.addEventListener('canplay', playIntroVideo);
            videoRef.current.addEventListener('ended', ended);
            videoRef.current.addEventListener('loadeddata', loadeddata);
            videoRef.current.addEventListener('waiting', waiting);
            videoRef.current.addEventListener('playing', playing);
            videoRef.current.addEventListener('loadedmetadata', onloadMeta);
        }
        return () => {
            if (videoRef.current) {
                videoRef.current.addEventListener('error', error)
                videoRef.current.removeEventListener('canplay', playIntroVideo);
                videoRef.current.removeEventListener('ended', ended);
                videoRef.current.removeEventListener('loadeddata', loadeddata);
                videoRef.current.removeEventListener('waiting', waiting);
                videoRef.current.removeEventListener('playing', playing);
                videoRef.current.removeEventListener('loadedmetadata', onloadMeta);
            }
        }
    }, [videoRef])

    const playIntroVideo = () => {
        if (autoplayPermissionsDenied) {
            if (isPlayerInteractedRef.current) {
                const playPromise = videoRef.current.play();
                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                        setAutoplayPermissionsDenied(false);
                        })
                }
            }
        } else {
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => { }).catch(() => {
                    setAutoplayPermissionsDenied(true);
                })
            }
        }
    }

    return (
        <video
            ref={videoRef}
            playsInline
            muted={isMuted}
            src={`${playList[playingVideoIndex].src}#t=0.1`}
            className={`intro-video-element${isFirstFrameLoaded ? ' visible' : ''}`}>
        </video>
    )
}
